export const TauxTva = [0, 0.085, 0.2, 0.055, 0.1] as const
export type TauxTva = typeof TauxTva[number]
